import { render, staticRenderFns } from "./ViewPublic.vue?vue&type=template&id=bcf0ebd8&"
import script from "./ViewPublic.vue?vue&type=script&lang=js&"
export * from "./ViewPublic.vue?vue&type=script&lang=js&"
import style0 from "./ViewPublic.vue?vue&type=style&index=0&id=bcf0ebd8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports